module.exports = __webpack_public_path__ + "static/img/image.7d7f7c53.jpg";